import React, { useState } from "react";
import { getProviderProfile } from "../../services/providersApi";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import { fetchProviderImages } from "../../services/imageService";
import { generateQRCode } from "../../services/imageService";
import ExportableProfile from "../ExportableProfile/ExportableProfile";

const ExportImageButton = ({ providerId, type }) => {
    const [loading, setLoading] = useState(false);
    const [providerData, setProviderData] = useState(null);
    const [images, setImages] = useState({});
    const [qrCode, setQrCode] = useState(null);

    const handleExport = async () => {
        if (loading) return;

        setLoading(true);
        try {
            // Cargar datos dinámicamente al presionar el botón
            const data = await getProviderProfile(providerId);
            setProviderData(data);

            const imgs = await fetchProviderImages(data);
            setImages(imgs);

            const profileUrl = `https://contactame.com.ar/${data.username}`;
            const qr = await generateQRCode(profileUrl);
            setQrCode(qr);

            // Esperamos un tick para que React renderice el DOM oculto
            setTimeout(async () => {
                const element = document.getElementById("exportable-profile");
                if (!element) {
                    toast.error("Elemento exportable no encontrado");
                    setLoading(false);
                    return;
                }

                const canvas = await html2canvas(element, { useCORS: true, scale: 2 });
                const imgData = canvas.toDataURL("image/png");
                const link = document.createElement("a");
                link.download = `CONTACTAME_${data.name.replace(/\s+/g, "-")}.png`;
                link.href = imgData;
                link.click();
                toast.success("Imagen exportada correctamente");
                setLoading(false);
            }, 100); // Pequeño delay para asegurarse de que el DOM esté actualizado
        } catch (error) {
            if (error.response && error.response.status === 404) {
                toast.error("No se encontró el perfil, recordá que debe estar activo.");
            } else {
                toast.error("Error al exportar imagen");
            }
            console.error("Error exportando imagen:", error);

            setLoading(false);
        }
    };

    return (
        <>
            <button
                className="new-btn"
                style={{backgroundColor:"#0056b3"}}
                onClick={handleExport}
                disabled={loading}
            >
                {loading ? (
                    "Generando imagen..."
                ) : (
                    <>
                        Exportar a imagen
                    </>
                )}
            </button>

            {/* Uso del componente exportable centralizado */}
            {providerData && qrCode && (
                <ExportableProfile
                    providerData={providerData}
                    images={images}
                    type={type}
                    qrCode={qrCode}
                />
            )}
        </>
    );
};

export default ExportImageButton;
